import { usePeopleBehind } from "../hooks/index";
import { Link } from "react-router";
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
const PeopleBehindPage = () => {
  const { data, isLoading, status } = usePeopleBehind();
  if (isLoading) return <div className="spinner"></div>;

  if (status === "failed")
    return (
      <h4 className="my-5 py-5  text-center getInvolvedline">
        No Data Available
      </h4>
    );
  const peopleBehindData = data?.peopleBehind;

  if (peopleBehindData === undefined)
    return (
      <h4 className="my-5 py-5  text-center getInvolvedline">
        No Data Available
      </h4>
    );

  return (
    <div className="App container my-4">
      <h3 className="text-center mb-4">People Behind</h3>
      <div className="row">
        {peopleBehindData?.map((person) => (
          <div key={person.id} className="col-md-6 mb-4">
            <Link
              // to={`/people-behind/peopleBehind/${person.id}`}
              className="text-decoration-none"
              // onClick={() => {
              //   scrollToTop();
              // }}
            >
              <div className="card shadow-sm p-3 d-flex flex-row align-items-center">
                <img
                  // src={person.image}
                    src={`${process.env.REACT_APP_BASE_IMG_URL+person?.images[0]?.url}`}
                  alt={person.name}
                  className="rounded-circle me-3"
                  width="80"
                  height="80"
                />
                <div>
                  <h5 className="fw-bold">{person.name}</h5>
                  {person.designation && (
                    <p className="mb-1">{person.designation}</p>
                  )}
                  <p className="text-muted">{person.location}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
export default PeopleBehindPage;
